// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__C7fiH","rightButtons":"Footer_rightButtons__LLd2z"};